import React, { useState, useEffect } from 'react';
import { AlertCircle, CheckCircle, Mail, User, Phone, ArrowRight } from 'lucide-react';
import { gsap } from 'gsap';
import styles from '../styles/components/_NewsletterForm.module.scss';

const NewsletterForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    firstname: '',
    name: '',
    phone: ''
  });
  
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null
  });

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (step === 1) {
        // Entrée de l'étape 1
        if (document.querySelector('.title')) {
          gsap.from('.title', {
            y: -30,
            opacity: 0,
            duration: 0.8,
            ease: 'power3.out'
          });
        }
  
        if (document.querySelector('.description')) {
          gsap.from('.description', {
            y: -20,
            opacity: 0,
            duration: 0.8,
            delay: 0.2,
            ease: 'power3.out'
          });
        }
  
        if (document.querySelector('.benefit')) {
          gsap.from('.benefit', {
            x: -30,
            opacity: 0,
            stagger: 0.15,
            duration: 0.8,
            delay: 0.4,
            ease: 'power3.out'
          });
        }
  
        if (document.querySelector('.button')) {
          gsap.from('.button', {
            y: 20,
            opacity: 0,
            duration: 0.8,
            delay: 0.8,
            ease: 'power3.out'
          });
        }
      } else {
        // Entrée du formulaire
        if (document.querySelector('.formTitle')) {
          gsap.from('.formTitle', {
            scale: 0.9,
            opacity: 0,
            duration: 0.6,
            ease: 'power3.out'
          });
        }
  
        if (document.querySelector('.form > *')) {
          gsap.from('.form > *', {
            y: 20,
            opacity: 0,
            stagger: 0.1,
            duration: 0.6,
            delay: 0.2,
            ease: 'power3.out'
          });
        }
      }
    });
  
    return () => ctx.revert();
  }, [step]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('handleSubmit appelé');
    setStatus({ loading: true, success: false, error: null });

    const formDataForLog = {
      email: formData.email,
      firstname: formData.firstname,
      name: formData.name,
      phone: formData.phone
    };
    console.log('Données du state:', formDataForLog);

    try {
      console.log('Début du bloc try');
      // Validation des champs obligatoires
      if (!formData.email || !formData.firstname || !formData.name || !formData.phone) {
        console.error('Erreur: Validation champs vides échouée');
        throw new Error('Tous les champs marqués * sont obligatoires.');
      }
      console.log('Validation champs vides: OK');

      // Validation de l'email
      const emailRegex = /^[\s\S]+@[\s\S]+\.[\s\S]+$/; // Regex simplifiée pour test
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex originale
      if (!emailRegex.test(formData.email)) {
        console.error('Erreur: Validation email échouée');
        throw new Error('Email invalide');
      }
      console.log('Validation email: OK');

   // Utiliser l'URL complète directe au lieu du proxy
   const apiUrl = 'https://www.poneyclubtoulouse.fr/scripts/subscribe.php';
      console.log(`Tentative de fetch vers: ${apiUrl}`);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: formData.email.trim(),
          firstname: formData.firstname.trim(),
          name: formData.name.trim(),
          phone: formData.phone.trim()
        })
      });

      console.log(`Réponse reçue de ${apiUrl}, Statut: ${response.status}`);
      console.log('Headers de réponse:', Object.fromEntries([...response.headers.entries()]));

      // Lire la réponse comme texte BRUT d'abord pour le débogage
      const responseText = await response.text();
      console.log('Réponse brute reçue du serveur:', responseText); 

      // Essayer de parser le texte en JSON
      let data;
      try {
        // Vérifier si la réponse commence par '<' (HTML) ou est vide
        if (responseText.trim().startsWith('<') || responseText.trim() === '') {
          console.error('Réponse non-JSON détectée (possiblement HTML ou vide)');
          // Créer un objet de données par défaut pour continuer le traitement
          data = { 
            success: false, 
            message: 'Le serveur a renvoyé une réponse invalide. Veuillez réessayer ultérieurement.' 
          };
        } else {
          data = JSON.parse(responseText);
          console.log('Données JSON parsées avec succès:', data);
        }
      } catch (parseError) {
        console.error('Erreur de parsing JSON:', parseError);
        console.error('Le texte brut reçu n\'était probablement pas du JSON valide.');
        
        // Créer un objet de données par défaut en cas d'erreur de parsing
        data = { 
          success: false, 
          message: 'Réponse invalide du serveur - veuillez contacter l\'administrateur' 
        };
      }

      // Si la réponse HTTP n'est pas 2xx ou si data.success est explicitement false
      if (!response.ok || (data && data.success === false)) {
        console.error('Erreur: Réponse non-OK ou échec explicite', data);
        throw new Error(data.message || 'Une erreur est survenue lors de l\'inscription');
      }

      console.log('Fetch réussi !');
      setStatus({ loading: false, success: true, error: null });
      setStep(1); // Retour à l'étape 1 après succès

    } catch (error) {
      console.error('Erreur dans le bloc catch:', error);
      setStatus({
        loading: false,
        success: false,
        error: error.message || 'Une erreur inconnue est survenue'
      });
    }
  };

  const renderStep1 = () => (
    <div className={`${styles.step} ${step === 1 ? styles.active : styles.inactive}`}>
      <div className={styles.stepContent}>
        <div>

        <h3 className={styles.title}>Rejoignez notre communauté</h3>
        <p className={styles.description}>
          Restez informé des derniers événements et des offres exclusives
        </p>
       
        </div>
        
        <div className={styles.benefits}>
        <div className={styles.stepContent}>
        {status.success || status.error ? (
          <div className={`${styles.message} ${status.success ? styles.success : styles.error}`}>
            {status.success ? <CheckCircle /> : <AlertCircle />}
            <span>{status.success ? 'Bienvenue dans la communauté !' : status.error}</span>
          </div>
        ) : null}

        <form onSubmit={handleSubmit} noValidate className={styles.form}>
          <div className={styles.inputGroup}>
            <Mail className={styles.inputIcon} />
            <input
              type="text"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
            />
          </div>

          <div className={styles.inputRow}>
            <div className={styles.inputGroup}>
              <User className={styles.inputIcon} />
              <input
                type="text"
                name="firstname"
                placeholder="Prénom *"
                value={formData.firstname}
                onChange={handleChange}
                className={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <User className={styles.inputIcon} />
              <input
                type="text"
                name="name"
                placeholder="Nom *"
                value={formData.name}
                onChange={handleChange}
                className={styles.input}
              />
            </div>
          </div>

          <div className={styles.inputGroup}>
            <Phone className={styles.inputIcon} />
            <input
              type="text"
              name="phone"
              placeholder="Téléphone *"
              value={formData.phone}
              onChange={handleChange}
              className={styles.input}
            />
          </div>

          <div style={{ display: 'flex', gap: '1rem' }}>
           
            <button
              type="submit"
             className="custom-button custom-button--light"
              disabled={status.loading}
              style={{ flex: 2 }}
            >
              {status.loading ? 'Inscription...' : 'Envoyer'}
              <ArrowRight className={styles.buttonIcon} />
            </button>
          </div>
        </form>
      </div>
        </div>

   
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div className={`${styles.step} ${step === 2 ? styles.active : styles.inactive}`}>
  
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {renderStep1()}
        {renderStep2()}
      </div>
    </div>
  );
};

export default NewsletterForm;